import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as cls from "./modalDeadLock.module.scss";
import { Button } from "../../../personal-studio-components/form";

export default function ModalDeadLock() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const { isDead_lock } = useSelector((state) => state.deadLock);
  const [open, setOpen] = useState(isDead_lock || false);
  const { dead_lock_message } = useSelector((state) => state.deadLock);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
      disableEscapeKeyDown
    >
      <DialogContent>
        <p dangerouslySetInnerHTML={{ __html: dead_lock_message }}></p>
      </DialogContent>
      <div>
        <DialogActions classes={{ paper: cls.dialogContnent }}>
          <Button onClick={handleClose} type="primary">
            Закрыть
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
